import React, { useContext } from "react";
import moment from "moment";
import "moment/locale/fr";
import MomentUtils from "@date-io/moment";
import { IntlProvider } from "react-intl";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import { ToastProvider } from "react-toast-notifications";

import messagesFr from "./translations/locales/fr.json";
import messagesEn from "./translations/locales/en.json";

import { default_locale, LanguageContext } from "./context/LanguageContext";
import { createTheme } from "./theme/ICIP";
import { AppRouter } from "./common/AppRoute";
import { AppContext } from "./context/AppContext";

interface Props {}

function loadLocaleData(locale: string) {
  switch (locale) {
    case "fr":
      return messagesFr;
    case "en":
      return messagesEn;
    default:
      return messagesEn;
  }
}

const App: React.FC<Props> = (props) => {
  const theme = createTheme({});
  const locale = useContext(LanguageContext);
  moment.locale(locale.localeCode);

  return (
    <IntlProvider
      locale={locale.localeCode}
      defaultLocale={default_locale}
      messages={loadLocaleData(locale.localeCode)}
    >
      <ThemeProvider theme={theme}>
        <AppContext>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <ToastProvider>
              <Router>
                <Switch>
                  <AppRouter />
                </Switch>
              </Router>
            </ToastProvider>
          </MuiPickersUtilsProvider>
        </AppContext>
      </ThemeProvider>
    </IntlProvider>
  );
};

export async function bootstrapApplication() {
  return <App />;
}
